export default "__VITE_ASSET__DhIy6Zal__"